import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";
import { Modal, Button, Container, Row, Col } from "react-bootstrap";
import RepairServices from "../../../services/RepairServices";

function ApproveOrRejectionModal({ show, item, handleClose, onSuccess }) {
  const [errormsg, setErrormsg] = useState("");

  const [formValues, setFormValues] = useState({
    invPartNo: "",
    invDescription: "",
    masterPartNo: "",
    masterDescription: "",
    unit: "",
    qtyRequired: 0,
    approveQty: "",
    adminRemark: "",
    repairOrderNo: "",
    store: "",
    user: "",
  });

  // --------------------------------------------------
  // LOAD VALUES WHEN ITEM CHANGES
  // --------------------------------------------------
  useEffect(() => {
    if (!item) return;

    const master = item.masterlist;
    const inv = item.repairOrder?.inventory;

    setFormValues({
      invPartNo: inv?.masterItem?.partNo || "",
      invDescription: inv?.masterItem?.description || "",

      masterPartNo: master?.partNo || "",
      masterDescription: master?.description || "",
      unit: master?.unit?.name || "",  // from Masterlist only ✔

      qtyRequired: item.qtyRequired || 0,
      approveQty: item.qtyRequired || 0,   // ⭐ AUTO-FILL APPROVE QTY HERE

      adminRemark: "",
      repairOrderNo: item.repairOrder?.repairOrderNo || "",
      store: item.store?.name || "",
      user: item.user?.name || "",
    });
  }, [item]);

  // --------------------------------------------------
  // HANDLE INPUT CHANGE
  // --------------------------------------------------
  const handleInputChange = (e) => {
    const { name, value } = e.target;

    if (name === "approveQty" && Number(value) > formValues.qtyRequired) {
      setErrormsg("Approved Qty cannot exceed Requested Qty!");
    } else {
      setErrormsg("");
    }

    setFormValues({ ...formValues, [name]: value });
  };

  // --------------------------------------------------
  // APPROVE OR REJECT
  // --------------------------------------------------
  const handleSubmit = async (event, status) => {
    event.preventDefault();

    if (status === "approvedByAdmin") {
      if (!formValues.approveQty || formValues.approveQty <= 0) {
        Swal.fire("Error", "Approve Qty must be > 0", "error");
        return;
      }
    }

    if (status === "rejected" && !formValues.adminRemark) {
      Swal.fire("Error", "Remark is required for rejection", "error");
      return;
    }

    try {
      await RepairServices.updateItem(item._id, {
        approveQty: formValues.approveQty,
        adminRemark: formValues.adminRemark,
        status,
      });

      Swal.fire("Success", `Request ${status}`, "success");
      onSuccess();
      handleClose();
    } catch (err) {
      Swal.fire("Error", "Unable to update repair request", "error");
      console.error(err);
    }
  };

  return (
    <Modal show={show} onHide={handleClose} size="lg">
      <Modal.Header>
        <Modal.Title>Repair Request Approval</Modal.Title>
        <Button variant="close" onClick={handleClose}></Button>
      </Modal.Header>

      <Modal.Body>
        <Container>
          <Row>
            <Col md="6">
              <label>Repair Order No</label>
              <input className="form-control form-control-sm" value={formValues.repairOrderNo} readOnly />
            </Col>

            <Col md="6">
              <label>Inventory Part No</label>
              <input className="form-control form-control-sm" value={formValues.invPartNo} readOnly />
            </Col>
          </Row>

          <Row className="mt-2">
            <Col md="12">
              <label>Inventory Description</label>
              <textarea className="form-control form-control-sm" rows="1" value={formValues.invDescription} readOnly />
            </Col>
          </Row>

          <Row className="mt-2">
            <Col md="6">
              <label>Repair Part No (Masterlist)</label>
              <input className="form-control form-control-sm" value={formValues.masterPartNo} readOnly />
            </Col>

            <Col md="6">
              <label>Repair Description</label>
              <textarea className="form-control form-control-sm" rows="1" value={formValues.masterDescription} readOnly />
            </Col>
          </Row>

          <Row className="mt-2">
            <Col md="4">
              <label>Unit</label>
              <input className="form-control form-control-sm" value={formValues.unit} readOnly />
            </Col>
          </Row>

          <Row className="mt-2">
            <Col md="6">
              <label>Requested Qty</label>
              <input className="form-control form-control-sm" value={formValues.qtyRequired} readOnly />
            </Col>

            <Col md="6">
              <label>Approve Qty</label>
              <input
                type="number"
                name="approveQty"
                className="form-control form-control-sm"
                value={formValues.approveQty}
                onChange={handleInputChange}
              />
              {errormsg && <small className="text-danger">{errormsg}</small>}
            </Col>
          </Row>

          <Row className="mt-2">
            <Col md="12">
              <label>Remarks (Required If Reject)</label>
              <textarea
                name="adminRemark"
                className="form-control form-control-sm"
                rows="1"
                value={formValues.adminRemark}
                onChange={handleInputChange}
              />
            </Col>
          </Row>

          <Row className="mt-2">
            <Col md="6">
              <label>User</label>
              <input className="form-control form-control-sm" value={formValues.user} readOnly />
            </Col>

            <Col md="6">
              <label>Store</label>
              <input className="form-control form-control-sm" value={formValues.store} readOnly />
            </Col>
          </Row>

        </Container>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="success" onClick={(e) => handleSubmit(e, "approvedByAdmin")}>
          Approve
        </Button>

        <Button variant="danger" onClick={(e) => handleSubmit(e, "rejected")}>
          Reject
        </Button>

        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default ApproveOrRejectionModal;
